<template>
  <v-container>
    <h2 style="color:gray">Cài đặt Hoạt động khác</h2>
    <v-divider class="my-3" />
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-others-group"
          :label="'Cho phép ' + roleName + ' thiết lập hoạt động khác'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>

      <!-- sự kiện -->
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-event-list"
          :label="'Cho phép ' + roleName + ' xem danh sách sự kiện'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="create-event"
          :label="'Cho phép ' + roleName + ' thêm sự kiện'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-event"
          :label="'Cho phép ' + roleName + ' sửa sự kiện'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="remove-event"
          :label="'Cho phép ' + roleName + ' xoá sự kiện'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>

      <!-- Khảo sát -->
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-survey"
          :label="'Cho phép ' + roleName + ' xem khảo sát'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="create-survey"
          :label="'Cho phép ' + roleName + ' thêm khảo sát'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-survey"
          :label="'Cho phép ' + roleName + ' sửa khảo sát'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-survey"
          :label="'Cho phép ' + roleName + ' xoá khảo sát'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>

      <!-- Câu lạc bộ -->
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-club"
          :label="'Cho phép ' + roleName + ' xem câu lạc bộ'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="create-club"
          :label="'Cho phép ' + roleName + ' thêm câu lạc bộ'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-club"
          :label="'Cho phép ' + roleName + ' sửa câu lạc bộ'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-club"
          :label="'Cho phép ' + roleName + ' xoá câu lạc bộ'"
          v-model="policies"
          class="ma-0 pa-0"
        />
      </v-col>
    </v-row>
    <v-divider class="my-3" />
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>
<script>
import mixins from './helper/mixins'
export default { mixins: [mixins] }
</script>
